import React from 'react'
import { Link } from 'react-router-dom'
import { I18n } from 'react-i18next'

import AluKHeader from './AluKHeader'
import backGroundVideo from '../assets/videos/aluk.mp4'
import regions from '../config/regions'
import i18n from '../config/i18n'

class Video extends React.Component {
  constructor (props) {
    super(props)

    // Init from parent
    this.handles = props.handles
    this.region = props.region

    // Or standalone call (first step before configurator)
    if (typeof props.match !== 'undefined') {
      // Init i18n
      const region = props.match.params.region
      this.region = region

      let lang

      regions.forEach((continent) => {
        const r = continent.countries.find((c) => c.id === region)
        if (typeof r !== 'undefined') {
          lang = r.lang
          this.handles = require('../config/handles/' + r.colorSet + '.json')
        }
      })

      i18n.changeLanguage(lang)
    }
  }

  render () {
    const { match } = this.props
    return [
      <I18n>
        {(t, { i18n }) => [
          <AluKHeader key='aluk-header' />,
          <video
            key='bg-video'
            preload='auto'
            playsInline
            autoPlay
            muted
            loop
            style={{
              maxWidth: '100%',
              maxHeight: '60%',
              marginLeft: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <source src={backGroundVideo} type='video/mp4' />
          </video>,
          <Link
            key='to-handle-picker-link'
            to={'/' + match.params.region + '/novae'}
            className='configurator-red-button center-block'
          >
            {t('configurator.configureNow')}
          </Link>
        ]}
      </I18n>
    ]
  }
}

export default Video

/*
const Video = ({ match }) => (
  <I18n>
    {(t, { i18n }) => [
      <AluKHeader key='aluk-header' />,
      <video
        key='bg-video'
        preload='auto'
        playsInline
        autoPlay
        muted
        loop
        style={{
          maxWidth: '100%',
          maxHeight: '60%',
          marginLeft: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <source src={backGroundVideo} type='video/mp4' />
      </video>,
      <Link
        key='to-handle-picker-link'
        to={'/' + match.params.region + '/novae'}
        className='configurator-red-button center-block'
      >
        {t('configurator.configureNow')}
      </Link>
    ]}
  </I18n>
)
*/



// WEBPACK FOOTER //
// ./src/components/Video.js